import request from '@/utils/request'

import requestUrl from '@/utils/requestApi'


//注册
export function register(data) {
    return request({
        url: requestUrl.register,
        method: 'POST',
        data: data
    })
}

// 登录
export function login(data) {
    return request({
        url: requestUrl.login,
        method: 'POST',
        data: data
    })
}

//退出登录
export function loginOut(params) {
    return request({
        url: requestUrl.loginOut,
        method: 'GET',
        params: params
    })
}


//手机号验证码登录
export function loginBuyPhone(params) {
    return request({
        url: requestUrl.loginBuyPhone,
        method: 'POST',
        params: params
    })
}

// 找回密码
export function retrievePassword(data) {
    return request({
        url: requestUrl.retrievePassword,
        method: 'POST',
        data: data
    })
}

//获取手机验证码
export function getSmsCode(params) {
    return request({
        url: requestUrl.getSmsCode,
        method: 'GET',
        params: params
    })
}

//获取用户信息
export function getUserInfo(params) {
    return request({
        url: requestUrl.getUserInfo,
        method: 'GET',
        params: params
    })
}

// 获取图形验证码
export function getCaptcha(params) {
    return request({
        url: requestUrl.getCaptcha + "?telephone=" + params,
        method: 'GET',
        name: "getCode",
        // params: params
    })
}



// WEBPACK FOOTER //
// ./src/api/auto.js